<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-navy">
    <div class="container">
      <!-- Logo on the left -->
      <router-link class="navbar-brand d-flex align-items-center" to="/">
        <img :src="logo" alt="HR Maintenance Logo" class="navbar-logo" />
        <span class="ms-2">HR Maintenance and Cleaning LLC</span>
      </router-link>

      <!-- Navbar Toggler (Mobile) -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navbar Links -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/contact">Contact</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "SiteHeader",
  data() {
    return {
      logo: "/assets/logos/logo-cropped.png", // Path for `public/` folder
      // If using `src/assets/`, use: logo: require("@/assets/logos/logo HR-06.png"),
    };
  }
};
</script>

<style scoped>
/* Custom navy blue background */
.bg-navy {
  background-color: #001f3f !important; /* Navy blue */
}

/* Ensure all text inside navbar stays white */
.navbar .nav-link,
.navbar-brand {
  color: white !important;
}

/* Navbar Logo */
.navbar-logo {
  height: 50px; /* Adjust logo size */
  width: auto;
  max-width: 100%;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .navbar-logo {
    height: 40px; /* Smaller logo for mobile */
  }
}
</style>
